import { useState, useEffect } from 'react';
import { Modal, Table, Button, Form, Alert } from 'react-bootstrap';

const SelectiveMerge = (props) => {
    const [changes, setChanges] = useState<any[]>([]);

    useEffect(() => {
        let changes: any[] = [];

        for (let i = 0; i < props.changes.length; i++) {
            const change = props.changes[i];
            let fieldName = '';

            if (change.FieldName.includes('-')) {
                const field = change.FieldName.split('-');
                const fieldNamePrefix = getArrayFieldName(field[0]);
                const fielNameNumber = parseInt(field[1]) + 1;
                const fieldNameSuffix = getArrayFieldName(field[2]);
                fieldName = fieldNamePrefix + ' ' + fielNameNumber + ' ' + fieldNameSuffix;
            } else {
                fieldName = getFieldName(change.FieldName);
            }

            if (fieldName === 'applicationSubCode') { continue; }
            if (fieldName === 'fileNo') { continue; }

            changes.push({
                fieldName,
                oldValue: change.OldValue,
                newValue: change.NewValue,
                name: change.FieldName
            });
        }

        setChanges(changes);
    }, [props.changes]);

    const onChange = (event) => {
        const name = event.target.name;
        const checked = event.target.checked;
        let currentChanges = props.acceptedChanges;

        if (checked) {
            currentChanges.push(name);
        } else {
            currentChanges = currentChanges.filter((item) => {
                return item !== name
            })
        }

        props.setAcceptedChanges(currentChanges);
    }

    const accept = () => {
        if (props.acceptedChanges.length === 0) {
            // MODAL GOES HERE
            alert('Please select changes to merge!');
            return;
        }
        props.acceptChanges();
    }

    const reject = () => {
        props.rejectChanges();
    }


    return (
        <>
            <Modal
                show={props.showModal}
                onHide={props.onHideModal}
                size='lg'
                aria-labelledby='contained-modal-title-vcenter'
                centered
                className="modal-list"
            >
                <Modal.Header closeButton>
                    <Modal.Title id='contained-modal-title-vcenter'>Import Information Submitted by Client</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <Table>
                        <thead>
                            <tr>
                                <th>Submitted Field</th>
                                <th>Submitted Data</th>
                                <th>Existing Data</th>
                                <th>Accept Data</th>
                            </tr>
                        </thead>
                        <tbody>
                        {changes.length > 0 ? (
                            changes.map((change, index) => (
                                <tr key={change.fieldName + index}>
                                    <td>{change.fieldName}</td>
                                    <td>{change.newValue}</td>
                                    <td>{change.oldValue}</td>
                                    <td>
                                        <Form.Check
                                            type='checkbox'
                                            name={change.name}
                                            onChange={onChange}
                                        />
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan={4} style={{padding: '0px'}}>
                                    <Alert variant="primary">No information to display.</Alert>
                                </td>
                            </tr>           
                        )}
                    </tbody>
                    </Table>
                </Modal.Body>

                <Modal.Footer>
                    <Button onClick={accept} disabled={changes.length === 0}>Accept</Button>
                    <Button onClick={reject} disabled={changes.length === 0} variant='secondary'>Reject All</Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}

const getFieldName = (fieldName) => {
    let fN = fieldName;
    switch (fieldName) {
        case 'propertyType':
            fN = 'PROPERTY TYPE';
            break;
        case 'propertyAddress':
            fN = 'PROPERTY ADDRESS';
            break;
        case 'streetNumber':
            fN = 'STREET NUMBER';
            break;
        case 'streetNumberSuffix':
            fN = 'SUFFIX';
            break;
        case 'streetName':
            fN = 'STREET NAME';
            break;
        case 'unitType':
            fN = 'UNIT TYPE';
            break;
        case 'unitNumber':
            fN = 'UNIT NUMBER';
            break;
        case 'city':
            fN = 'CITY/TOWN';
            break;
        case 'postalCode':
            fN = 'POSTAL CODE';
            break;
        case 'closingDate':
            fN = 'CLOSING DATE';
            break;
        case 'propertyPrice':
            fN = 'PROPERTY PRICE';
            break;
        case 'employer':
            fN = 'EMPLOYER';
            break;
        case 'occupation':
            fN = 'OCCUPATION';
            break;
        case 'businessAddress':
            fN = 'BUSINESS ADDRESS';
            break;
        case 'middleName':
            fN = 'MIDDLE NAME'
            break;
        case 'firstName':
            fN = 'FIRST NAME'
            break;
        case 'lastName':
            fN = 'LAST NAME'
    }

    return fN;
}

const getArrayFieldName = (fieldName) => {
    let fN = fieldName;
    switch (fieldName) {
        case 'buyers':
            fN = 'BUYER';
            break;
        case 'buyerName':
            fN = 'BUYER NAME';
            break;
        case 'birthDate':
            fN = 'BIRTH DATE';
            break;
        case 'sellers':
            fN = 'SELLER';
            break;
        case 'sellerName':
            fN = 'SELLER NAME';
            break;
        case 'clients':
            fN = 'CLIENT';
            break;
        case 'clientName':
            fN = 'CLIENT NAME';
            break;
        case 'genderCorp':
            fN = 'GENDER/CORPORATION';
            break;
        case 'cellPhoneNumber':
            fN = 'CELL PHONE NUMBER';
            break;
        case 'email':
            fN = 'EMAIL';
            break;
        case 'address':
            fN = 'CURRENT ADDRESS';
            break;
        case 'employer':
            fN = 'EMPLOYER';
            break;
        case 'occupation':
            fN = 'OCCUPATION';
            break;
        case 'businessAddress':
            fN = 'BUSINESS ADDRESS';
            break;
        case 'middleName':
            fN = 'MIDDLE NAME'
            break;
        case 'firstName':
            fN = 'FIRST NAME'
            break;
        case 'lastName':
            fN = 'LAST NAME'
    }

    return fN;
}

export default SelectiveMerge;